import React,{useContext} from 'react';
import uiContext from '../context/ui/uiContext';

function Errorpage(props) {
    const context=useContext(uiContext);
    return (
        <div>
            <h1>{context.widthSize}</h1>
            <h2>{context.sideBar}</h2>
        </div>
    );
}

export default Errorpage;